var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-combobox', {
    ref: "combobox",
    "class": _vm.className,
    attrs: {
      "items": _vm.tagSuggestions,
      "search-input": _vm.searchInput,
      "loading": _vm.loading,
      "label": _vm.label,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "dense": _vm.dense,
      "clearable": _vm.clearable,
      "outlined": _vm.outlined,
      "flat": _vm.flat,
      "hide-details": _vm.hideDetails,
      "background-color": _vm.backgroundColor,
      "prepend-inner-icon": _vm.prependInnerIcon,
      "required": _vm.required,
      "error-messages": _vm.errorMessages,
      "autofocus": _vm.autofocus,
      "item-text": "text",
      "item-value": "value",
      "return-object": "",
      "multiple": "",
      "chips": "",
      "deletable-chips": "",
      "filter": _vm.filterTags
    },
    on: {
      "update:searchInput": function updateSearchInput($event) {
        _vm.searchInput = $event;
      },
      "update:search-input": [function ($event) {
        _vm.searchInput = $event;
      }, _vm.onSearchInput]
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(_ref) {
        var item = _ref.item,
          index = _ref.index;
        return [_c('span', {
          key: "tag-".concat(index, "-").concat(_vm.getTagName(item)),
          staticClass: "tag-input-selection",
          on: {
            "mousedown": function mousedown($event) {
              $event.stopPropagation();
              $event.preventDefault();
            }
          }
        }, [_c('Tag', {
          attrs: {
            "tag": item,
            "size": "small",
            "closable": true,
            "chip-class": "mr-1 mt-1"
          },
          on: {
            "close": function close($event) {
              return _vm.removeTag(item);
            }
          }
        })], 1)];
      }
    }, {
      key: "item",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('v-list-item', {
          staticClass: "tag-suggestion-item",
          on: {
            "click": function click($event) {
              return _vm.selectTag(item);
            }
          }
        }, [_c('Tag', {
          attrs: {
            "tag": item,
            "size": "small",
            "chip-class": "mr-1 mb-1"
          }
        })], 1)];
      }
    }]),
    model: {
      value: _vm.selectedTags,
      callback: function callback($$v) {
        _vm.selectedTags = $$v;
      },
      expression: "selectedTags"
    }
  }, [_c('template', {
    slot: "no-data"
  }, [_c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.allowCreate ? _vm.$translate("noTagsFound") : _vm.$translate("noMatchingTags")) + " ")])], 1)], 1)], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }